import {
  OnChanges, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild,
  SimpleChanges
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FileService } from '../../services/file.service';
import { UtilsService } from '../../services/utils.service';
import { UploadService } from '../../services/upload.service';
import { GuidesService } from '../../services/guides.service';
import { environment } from '../../../environments/environment';
declare var UIkit: any;
declare var $: any;

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss']
})
export class FileComponent implements OnInit, OnChanges {
  static readonly PAGE_LIMIT = 10;
  private pageNumber: number;

  @Input('photos') photos: any[];
  @Input('videos') videos: any[];
  @Input('gallery') gallery: any[];

  @Input('serviceId') serviceId;

  @Input('showPhotos') showPhotos;
  @Input('showVideos') showVideos;
  @Input('showPhotoProps') showPhotoProps = true;

  @Input('customTitle') customTitle;

  @Input('singlePhotoAllowed') singlePhotoAllowed = false;
  @Input('id') id: string;
  @Input('idLabel') idLabel: string;
  @Input('showHeadshot') showHeadshot = false;
  @Input('headshot') headshot = false;
  @Input('showDelete') showDelete = true;
  @Input('showInline') showInline = false;
  @Input('showRemove') showRemove = false;

  @Input('showUpload') showUpload = true;

  @Input('meetTheLocal') meetTheLocal = [];
  @Input('featuredImage') featuredImage;
  @Input('showSetFeaturedImageOption') showSetFeaturedImageOption = false;
  @Input('showSetMeetTheLocalOption') showSetMeetTheLocalOption = false;

  @Input('showLegal') showLegal;
  @Input('legalDocs') legalDocs: any[];

  @Input('allowDeletePhotosVideos') allowDeletePhotosVideos: boolean = true;

  @ViewChild('fileUploadInput') fileUploadInput: ElementRef;
  @ViewChild('fileUploadButton') fileUploadButton: ElementRef;

  selectedFiles: File[];
  loadedPhotos = [];
  allCredit: string;
  fileToDelete;
  private responseCount = 0;
  serverUri = environment.server

  constructor(private fileService: FileService,
              private utilsService: UtilsService,
              private uploadService: UploadService,
              private guideService: GuidesService,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.photos && this.loadedPhotos.length === 0) {
      this.getMoreImages();
    }
  }

  selectFile(event) {
    if (event.target.files && event.target.files.length > 0) {
      const fileCount = event.target.files.length;
      let i;
      for (i = 0; i < fileCount; i++) {
        const tempFile = event.target.files[0];
        if (!this.showPhotos && this.isPhoto(event.target.files[i].type)) {
          this.utilsService.openSnackBar('No Photos Allowed', '');
          break;
        } else if (!this.showVideos && !this.isPhoto(event.target.files[i].type)) {
          this.utilsService.openSnackBar('No Videos Allowed', '');
          break;
        }
      }
      if (i === fileCount) {
        this.selectedFiles = event.target.files;
      }
    }
  }

  async upload() {
    const fileCount = this.selectedFiles.length;
    this.fileUploadButton.nativeElement.disabled = true;
    this.fileUploadButton.nativeElement.innerText = 'Uploading...';
    // Lets create small batches if selected files are more than batch size;
    const batches = this.utilsService.chunkArray(this.selectedFiles, 5);
    for (const batch of batches) {
      await this.uploadBatch(batch);
    }
    this.fileUploadInput.nativeElement.value = '';
    this.fileUploadButton.nativeElement.disabled = false;
    this.fileUploadButton.nativeElement.innerText = 'Upload';
    this.selectedFiles = [];
  }

  uploadBatch(files) {
    const self = this;
    const promises = [];
    const fileCount = files.length;
    for (let i = 0; i < fileCount; i++) {
      promises.push(this.uploadSingleFile(files[i]));
    }
    return Promise.all(promises);
  }

  uploadSingleFile(selectedFile) {
    const self = this;
    return new Promise((resolve, reject) => {
      this.uploadService.issuePreSignedURL(selectedFile).subscribe(result => {
        this.uploadService.uploadFileToS3(result['signedRequest'], selectedFile).subscribe(async (data) => {
          if (data && data.url) {
            console.log('data.url is coming now: ', data.url);
            const file = {
              path: result['fileName'],
              mimetype: selectedFile.type,
              serviceId: self.serviceId,
              [self.idLabel]: self.id,
              filename: selectedFile.name
            };
            if (self.singlePhotoAllowed && self.photos.length > 0) {
              const tempFile = self.photos[0];
              tempFile.path = file.path;
              tempFile.mimetype = file.mimetype;
              await self.updateFile(tempFile);
            } else {
              await self.createFile(file);
            }
            resolve();
          }
        }, err => {
          console.log(`Failed to upload the file`, selectedFile);
          // Lets not fail otherwise other files will also stopped processing.
          resolve();
        });
      });
    });
  }

  createFile(file) {
    this.fileService.createFile(file).subscribe(response => {
      if (response) {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          if (this.isPhoto(file.mimetype)) {
            this.photos.unshift(response.data.createFile);
            this.loadedPhotos.unshift(response.data.createFile);
          } else if (this.isPdf(file.mimetype)) {
            this.legalDocs.unshift(response.data.createFile);
          } 
          else {
            this.videos.unshift(response.data.createFile);
          }
          this.utilsService.openSnackBar('File uploaded!!', '');
        }
      }
    }, error => {
      this.utilsService.openSnackBar('Unable to upload file.', '');
      console.log('there was an error sending the query', error);
    });
  }

  getPhotoType(file): string {
    if (file.owned) return 'owned';
    if (file.licensed) return 'licensed';
    if (file.sublicenseable) return 'sublicenseable';
    return 'none'; // default if none selected
  }

  setPhotoType(file, value: string): void {
    file.owned = value === 'owned';
    file.licensed = value === 'licensed';
    file.sublicenseable = value === 'sublicenseable';

    this.updateFile(file); // persist changes to backend
  }

  updateFile(file) {
    console.log("[updateFile].File", file)
    this.fileService.updateFile(file).subscribe((response) => {
      if (response.errors && response.errors.length > 0) {
        const errors = response.errors.map(err => err.message);
        this.utilsService.openSnackBar(errors, '');
      } else {
        this.utilsService.openSnackBar('file updated!!', '');
      }
    }, (error) => {
      this.utilsService.openSnackBar('Unable to upload file.', '');
      console.log('there was an error sending the query', error);
    });
  }

  deleteFile(file) {
    UIkit.modal($('#confirm-photo-delete')).hide();
    this.fileService.delete(file).subscribe(({data}) => {
      if (this.isPhoto(file.mimetype)) {
        this.photos = this.photos.filter((f) => f.id !== file.id);
        this.loadedPhotos = this.loadedPhotos.filter((f) => f.id !== file.id);
      } else if (this.isPdf(file.mimetype)) {
        this.legalDocs = this.legalDocs.filter((f) => f.id !== file.id);
      } else {
        this.videos = this.videos.filter((f) => f.id !== file.id);
      }
      this.utilsService.openSnackBar('File Deleted !!', '');
    }, (error) => {
      this.utilsService.openSnackBar('Unable to delete file.', '');
      console.log('there was an error sending the query', error);
    });
  }

  isPhoto(mimetype) {
    return mimetype.indexOf('image') > -1;
  }
  isPdf(mimetype) {
    return mimetype.indexOf('pdf') > -1;
  }

  viewOriginalImage(file) {
    window.open(file.originalUrl, '_blank');
  }

  downloadOriginalImage(file) {
    this.utilsService.getFile(file.originalUrl || file.url).subscribe((res) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(res);
      a.download = `mb-image-${this.utilsService.generateRandomString()} + ${res.type.substring(6)}`;
      document.body.appendChild(a);
      a.click();
    });
  }

  addToMeetTheLocal(file) {
    const data = {
      [this.idLabel]: this.id,
      idLabel: this.idLabel,
      imageId: file.id
    };
    this.fileService.addToMeetTheLocal(data).subscribe(res => {
      this.meetTheLocal.push(file);
      this.utilsService.openSnackBar('Meet the local added successfully!', '');
    }, err => {
      this.utilsService.openSnackBar('Error adding meet the local!', '');
    });
  }

  removeFromMeetTheLocal(file) {
    const data = {
      [this.idLabel]: this.id,
      idLabel: this.idLabel,
      imageId: file.id
    };
    this.fileService.removeFromMeetTheLocal(data).subscribe(res => {
      this.meetTheLocal.splice(this.meetTheLocal.indexOf(file), 1);
      this.utilsService.openSnackBar('Meet the local removed successfully!', '');
    }, err => {
      this.utilsService.openSnackBar('Error removing meet the local!', '');
    });
  }

  setAsFeaturedImage(file) {
    const data = {
      [this.idLabel]: this.id,
      idLabel: this.idLabel,
      imageId: file.id
    };
    this.fileService.setAsFeaturedImage(data).subscribe(res => {
      this.utilsService.openSnackBar('Featured Image updated successfully!!', '');
    }, err => {
      this.utilsService.openSnackBar('Error updating featured image!', '');
    });
  }

  showAddToGallery(file) {
    if (!this.gallery) {
      return true;
    }
    return this.gallery.map(item => item.id).indexOf(file.id) === -1;
  }

  showSetFeaturedImage(file) {
    if (this.featuredImage) {
      return this.featuredImage.id !== file.id;
    }
    return this.showSetFeaturedImageOption;
  }

  showSetMeetTheLocal(file) {
    if (this.showSetMeetTheLocalOption) {
      if (!this.meetTheLocal) {
        return true;
      }
      const meetTheLocalIds = this.meetTheLocal.map(local => local.id);
      return meetTheLocalIds.indexOf(file.id) === -1;
    } else {
      return false;
    }
  }

  addToGallery(file) {
    const data = {
      [this.idLabel]: this.id,
      idLabel: this.idLabel,
      imageId: file.id
    };
    this.fileService.addToGallery(data).subscribe(res => {
      this.gallery.push(file);
      this.utilsService.openSnackBar('Image added to Gallery Successfully!!', '');
    }, err => {
      this.utilsService.openSnackBar('Error adding image to Gallery!!', '');
    });
  }

  removeFromGallery(file) {
    const data = {
      [this.idLabel]: this.id,
      idLabel: this.idLabel,
      imageId: file.id
    };
    this.fileService.removeFromGallery(data).subscribe(res => {
      this.gallery.splice(this.gallery.indexOf(file), 1);
      this.utilsService.openSnackBar('Image removed from Gallery Successfully!!', '');
    }, err => {
      this.utilsService.openSnackBar('Error removing image to Gallery!!', '');
    });
  }

  updateHeadshot(imageId) {
  
    this.guideService.updateHeadshot(this.id,imageId ).subscribe(res => {
      this.utilsService.openSnackBar('Headshot updated successfully!!', '');
    }, err => {
      this.utilsService.openSnackBar('Error updating headshot!', '');
    });
  }

  updatePremiumPhoto(file) {
    const data = {
      imageId: file.id,
      premium: file.premium
    };
    this.fileService.updatePremiumFlag(data).subscribe(res => {
      const msg = file.premium ? 'Image marked as premium!!' : 'Image removed from premium';
      this.utilsService.openSnackBar(msg, '');
    }, err => {
      this.utilsService.openSnackBar('Error updating premium image!!', '');
    });
  }

  updatePrivatePhoto(file) {
    const data = {
      imageId: file.id,
      private: file.private
    };
    this.fileService.updatePrivateFlag(data).subscribe(res => {
      const msg = file.private ? 'Image marked as private!!' : 'Image removed from private';
      this.utilsService.openSnackBar(msg, '');
    }, err => {
      this.utilsService.openSnackBar('Error updating private image!!', '');
    });
  }
  updateLegal(file) {
    const data = {
      fileId: file.id,
      legal: file.legal
    };
    this.fileService.updateLegalFlag(data).subscribe(res => {
      const msg = file.legal ? 'File marked as legal!!' : 'File removed from legal';
      this.utilsService.openSnackBar(msg, '');
    }, err => {
      this.utilsService.openSnackBar('Error updating legal doc!!', '');
    });
  }

  getMoreImages() {
    if (this.photos) {
      if (this.pageNumber >= 0) {
        this.pageNumber++;
      } else {
        this.pageNumber = 0;
      }
      const endRange = this.pageNumber * FileComponent.PAGE_LIMIT + FileComponent.PAGE_LIMIT;
      this.loadedPhotos = this.photos.slice(0, endRange);
    }
  }

  galleryOrderChanged(event) {
    const galleryOrder = event.map((image, index) => {
      return {
        imageId: image.id,
        sortOrder: index
      };
    });
    const data = {
      [this.idLabel]: this.id,
      files: galleryOrder,
      idLabel: this.idLabel
    };
    this.fileService.updateGalleryOrder(data).subscribe(res => {
      this.utilsService.openSnackBar('Order updated Successfully!', '');
    }, err => {
      this.utilsService.openSnackBar('Error while updating Order!', '');
    });
  }

  updateAllCredit() {
    UIkit.modal($('#confirm-all-update')).hide();
    const data = {
      credit: this.allCredit,
      imageIds: this.photos.map(photo => photo.id)
    };
    this.fileService.updateAllCredit(data).subscribe(res => {
      this.utilsService.openSnackBar('Credit for all photos updated Successfully!', '');
    }, err => {
      this.utilsService.openSnackBar('Error while updating credit for all photos!', '');
    });
  }

  downloadVideo(file) {
    window.open(file.url);
  }

  downloadDocument(file) {
    window.open(file.url);
  }
}


// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/file/file.component.ts